import { ACTIVITY_REPORT, PROJECT_MANAGEMENT_HOLIDAY_LIST } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../resources/serviceURLs';

const buildProjectManagementBaseURL = () => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}`;
  }

  return `${baseUrl}:${servicePort}${serviceURL}`;
};

export const getActivityReportUrl = () => `${buildProjectManagementBaseURL()}/api${ACTIVITY_REPORT}`;

export const getActivityReportHolidayListRequest = ({ startDate, endDate, token } = {}) => {
  const url = new URL(`${buildProjectManagementBaseURL()}/api${PROJECT_MANAGEMENT_HOLIDAY_LIST}`);

  if (startDate) {
    url.searchParams.set('startDate', startDate);
  }

  if (endDate) {
    url.searchParams.set('endDate', endDate);
  }

  return {
    url: url.toString(),
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      token,
    },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};
